import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHero } from "@/components/Sections";
import { Skeleton } from "@/components/ui/skeleton";

export default function EarthFromSpace() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/epic");
        setItems(r.data.items || []);
      } catch (e) {
        console.error("EPIC load failed:", e);
      }
      finally { setLoading(false); }
    })();
  }, []);

  const featured = items[active];

  return (
    <>
      <PageHero
        eyebrow="Earth From Space"
        title="A million miles"
        accent="from home."
        subtitle="Full-disk images of Earth captured from a deep-space vantage point at the L1 Lagrange point — roughly a million miles from home."
      />

      <section className="max-w-7xl mx-auto px-6 pb-24">
        {loading ? (
          <Skeleton className="h-[60vh] w-full rounded-3xl" />
        ) : featured ? (
          <>
            <div className="glass p-5 md:p-8 fade-in-up" data-testid="earth-featured">
              <div className="grid lg:grid-cols-12 gap-8 items-center">
                <div className="lg:col-span-7">
                  <img src={featured.url} alt="Earth from space" className="w-full rounded-2xl glow-blue" loading="lazy" />
                </div>
                <div className="lg:col-span-5">
                  <div className="eyebrow">Deep-space imaging</div>
                  <h2 className="display mt-4 text-3xl md:text-4xl">{featured.caption || "Earth, captured."}</h2>
                  <div className="mt-4 text-sm text-white/55">{featured.date}</div>
                  {featured.centroid_coordinates && (
                    <div className="mt-2 text-xs text-white/45 font-mono">
                      lat {Number(featured.centroid_coordinates.lat).toFixed(2)}° ·
                      lon {Number(featured.centroid_coordinates.lon).toFixed(2)}°
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="mt-10 eyebrow-row"><span className="eyebrow">All images today</span></div>
            <div className="mt-6 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 stagger">
              {items.map((it, idx) => (
                <button
                  key={it.image}
                  onClick={() => setActive(idx)}
                  data-testid={`earth-thumb-${idx}`}
                  className={`glass hover-lift overflow-hidden aspect-square ${idx === active ? "ring-2 ring-white/60" : ""}`}
                >
                  <img src={it.thumb} alt="" className="w-full h-full object-cover" loading="lazy" />
                </button>
              ))}
            </div>
          </>
        ) : (
          <div className="glass p-10 text-white/70">No Earth images are available right now. Please check back later.</div>
        )}
      </section>
    </>
  );
}
